import { IpoTouchCheckService } from '@ip-only/front-end-library';
import { environment } from './../environments/environment';
import { OfflineKeycloakService } from './keycloak/service/keycloak.service';
import { loginFlow } from './login-flow';
import { AnalyticsService } from './shared/posthug-analytics/analytics.service';
import { ContractorUserApiService } from './user/api/contractor-user-api.service';
import { ResourcesService } from './user/resources.service';
import { UserService } from './user/user.service';

const clientIdsByUrl: Record<string, string> = {
  'globalconnect.se': 'delivery-portal',
  'globalconnect.fi': 'delivery-portal-fi',
  localhost: 'delivery-portal',
  'local-dev.se': 'delivery-portal',
  'local-dev.fi': 'delivery-portal-fi',
};

const buildKeycloakConfig = () => {
  const domainWithoutSubDomain = window.location.hostname
    .split('.')
    .slice(-2)
    .join('.');
  return {
    url: environment.keycloakConfig.url,
    realm: environment.keycloakConfig.realm,
    clientId: clientIdsByUrl[domainWithoutSubDomain],
  };
};

export function initializer(
  keycloak: OfflineKeycloakService,
  userService: UserService,
  resourceService: ResourcesService,
  contractorUserApiService: ContractorUserApiService,
  touchCheckService: IpoTouchCheckService,
  analyticsService: AnalyticsService,
): () => Promise<any> {
  return (): Promise<any> => {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises, no-async-promise-executor
    return new Promise(async (resolve) => {
      let isLoggedIn = false;
      try {
        isLoggedIn = await keycloak.init({
          config: buildKeycloakConfig(),
          initOptions: {
            checkLoginIframe: false,
            responseMode: 'query',
          },
        });
      } catch (error) {
        console.error('Keycloak initialization error:', error);
        resolve(false);
      }
      try {
        touchCheckService.init();
        // eslint-disable-next-line no-empty
      } catch (error) {}
      if (isLoggedIn) {
        try {
          await loginFlow(
            keycloak,
            userService,
            resourceService,
            contractorUserApiService,
          );
          analyticsService.setupCollection();
        } catch (error) {
          await keycloak.logout();
        }
      } else {
        await keycloak.login({ prompt: 'login' });
      }
      resolve(isLoggedIn);
    });
  };
}
